import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import { clearSurveySchemaPartOptionsAction, updateSurveySchemaPartOptionsAction } from '../../../actions';
import { surveyTypeValues } from '../../../constants/types';
import ModalDialog from '../../ModalDialog';
import { withLang } from '../../../i18n';
import LabelWrapper from '../../LabelWrapper';
import { Select } from '../../Select';

const SelectSurveyPartTypeDialog = ({
  confirmRoute, buttonText, labelText, dataCy, translate: t
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedType, setSelectedType] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleCancel = () => setIsOpen(false);

  const handleConfirm = () => {
    dispatch(clearSurveySchemaPartOptionsAction());
    dispatch(updateSurveySchemaPartOptionsAction({ surveyType: selectedType }));
    navigate(confirmRoute);
  };

  return (
    <>
      <button type="button" className="button--action icon--plus" onClick={() => setIsOpen(true)} data-cy={dataCy}>
        {buttonText}
      </button>
      <ModalDialog
        isOpen={isOpen}
        isLarge={false}
        onCancel={handleCancel}
        onConfirm={handleConfirm}
        cancelTranslationKey="common.cancel"
        confirmTranslationKey="common.continue"
        isValid={!!selectedType}
      >
        <h3>{t('selectSchemaTypeDialog.title')}</h3>
        <LabelWrapper label={labelText}>
          <div data-cy="schema-type-dialog-select">
            <Select
              options={Object.values(surveyTypeValues).map((type) => ({
                value: type,
                label: t(`surveyType.${type}`)
              }))}
              placeholderKey="common.select"
              value={selectedType}
              onChange={(value) => setSelectedType(value)}
            />
          </div>
        </LabelWrapper>
      </ModalDialog>
    </>
  );
};

const { func, string } = PropTypes;
SelectSurveyPartTypeDialog.propTypes = {
  confirmRoute: string.isRequired,
  buttonText: string.isRequired,
  labelText: string.isRequired,
  dataCy: string.isRequired,
  translate: func.isRequired
};

export default withLang(SelectSurveyPartTypeDialog);
